import { CreateApi } from "../../CreateApi";
import { Methods, Urls } from "../../../common/Utils/ApiConstants";

const assignedToMeTaskcollection = CreateApi.injectEndpoints({
  endpoints: (builder) => ({
    getAssignedToMeTaskData: builder.query({
      query: (pageNo) => {
        return {
          url: Urls.getAssignedToMeTaskList,
          method: Methods.get,
          params: { pageNo },
        };
      },
      transformResponse: (response) => {
        return response.data;
      },
    }),
  }),
});

export const { useLazyGetAssignedToMeTaskDataQuery } = assignedToMeTaskcollection;
